var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.welfare,attrs:{"id":"js-welfare-content"}},[_c('div',{staticClass:"app-fadeInUp"},[_c('the-welfare-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }